export default {
    TOGGLE_EDIT_MODE: 'TOGGLE_EDIT_MODE',    
};